import { Component, Input, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { DashboardQueries } from '../../../../cp/shared/enums/DashboardQueries';
import { widgetFilters } from '../../../shared/enums/widgetFilters';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';
import { Subscription } from 'rxjs';
import { FeatureFlagService } from '@app/cp/shared/services/feature-flag.service';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';

@Component({
    selector: 'cp-invoice-approvals',
    templateUrl: './invoice-approvals.component.html',
    styleUrls: ['./invoice-approvals.component.scss']
})
export class InvoiceApprovalsComponent implements OnInit, OnDestroy {

    constructor(private featureFlagService: FeatureFlagService) {
    }
    private subs_featureFlagSet: Subscription; //place as class variable
    featureFlagSet = {};
    ngOnInit(): void {
        this.subs_featureFlagSet = this.featureFlagService.featureFlagSets.subscribe((data: any) => {
            this.featureFlagSet = data;
            this.setWidgetFilters();
        });
    }
    ngOnDestroy(): void {
        CommonFunctions.unsubscribe(this.subs_featureFlagSet); //place in ngOnDestroy
    }

    @Input() chartType: string = 'donut';
    @Input() inputSearchParams: WidgetSearch;
    @Output() loaderState = new EventEmitter<any>();
    @Output() loaderErrorState = new EventEmitter<any>();
    @Output() searchParams = new EventEmitter<WidgetSearch>(true);

    widgetQuery: DashboardQueries = DashboardQueries.invoiceApprovals;
    chartSearchFilters: widgetFilters[];

    private setWidgetFilters() {
        this.chartSearchFilters = this.featureFlagSet["days-aged-invoice-approval"] ?
            [
                widgetFilters.invoiceStatusApproval,
                widgetFilters.customer,
                widgetFilters.acctMgr,
                widgetFilters.divisions,
                widgetFilters.contAdmin,
                widgetFilters.class,
                widgetFilters.state,
                widgetFilters.divisions,
                widgetFilters.onCallRegion,
                widgetFilters.svcConst,
                widgetFilters.biller,
                widgetFilters.discreetBiller,
                widgetFilters.defaultSubmitter,
                widgetFilters.daysAged
            ]
            :
            [
                widgetFilters.invoiceStatusApproval,
                widgetFilters.customer,
                widgetFilters.acctMgr,
                widgetFilters.divisions,
                widgetFilters.contAdmin,
                widgetFilters.class,
                widgetFilters.state,
                widgetFilters.divisions,
                widgetFilters.onCallRegion,
                widgetFilters.svcConst,
                widgetFilters.biller,
                widgetFilters.discreetBiller,
                widgetFilters.defaultSubmitter
            ];
    }

    changeLoader(e) {
        this.loaderState.emit(e);
    }

    changeErrorLoader(e) {
        this.loaderErrorState.emit(e);
    }

    setSearchParams(searchParams: WidgetSearch) {
        this.searchParams.emit(searchParams);
    }

}
